import React from 'react';
import { usePage } from 'api';
import { useParams } from 'react-router-dom';

export default function PagePreview(props) {
  const {companyId, pageId} = useParams();
  const page = usePage(companyId, pageId);
  
  if(!page) {
    return null;
  }
  
  return (
    <div>
      <style> 
        {page.css}
      </style>
      <div dangerouslySetInnerHTML={{__html:page.html}}/>
    </div>
  );
}